<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "magic-player-timeline" };
const _hoisted_2 = { class: "magic-player-timeline__track" };
const _hoisted_3 = { class: "magic-player-timeline__inner-track" };
import { inject } from "vue";
import { usePlayerControlsApi } from "../composables/private/usePlayerControlsApi";
import { MagicPlayerInstanceId } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicPlayerTimeline",
  setup(__props) {
    const instanceId = inject(MagicPlayerInstanceId, void 0);
    if (!instanceId) {
      throw new Error(
        "MagicPlayerPoster must be nested inside MagicPlayerVideoControls or MagicPlayerAudioControls."
      );
    }
    const {
      mouseEntered,
      seekedPercentage,
      scrubbedPercentage,
      bufferedPercentage,
      onMouseenter,
      onMouseleave,
      onPointerdown,
      onPointerup,
      onPointermove
    } = usePlayerControlsApi({
      id: instanceId
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode(
          "div",
          {
            class: "magic-player-timeline__target",
            onMouseenter: _cache[0] || (_cache[0] = //@ts-ignore
            (...args) => _unref(onMouseenter) && _unref(onMouseenter)(...args)),
            onMouseleave: _cache[1] || (_cache[1] = //@ts-ignore
            (...args) => _unref(onMouseleave) && _unref(onMouseleave)(...args)),
            onPointerdown: _cache[2] || (_cache[2] = //@ts-ignore
            (...args) => _unref(onPointerdown) && _unref(onPointerdown)(...args)),
            onPointerup: _cache[3] || (_cache[3] = //@ts-ignore
            (...args) => _unref(onPointerup) && _unref(onPointerup)(...args)),
            onPointermove: _cache[4] || (_cache[4] = //@ts-ignore
            (...args) => _unref(onPointermove) && _unref(onPointermove)(...args))
          },
          [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode(
                "div",
                {
                  class: "magic-player-timeline__thumb",
                  style: _normalizeStyle({ left: `${_unref(scrubbedPercentage)}%` })
                },
                _cache[5] || (_cache[5] = [
                  _createElementVNode(
                    "div",
                    { class: "magic-player-timeline__thumb-handle" },
                    null,
                    -1
                    /* HOISTED */
                  )
                ]),
                4
                /* STYLE */
              ),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode(
                  "div",
                  {
                    class: "magic-player-timeline__buffered",
                    style: _normalizeStyle({ left: `${_unref(bufferedPercentage)}%` })
                  },
                  null,
                  4
                  /* STYLE */
                ),
                _withDirectives(_createElementVNode(
                  "div",
                  {
                    class: "magic-player-timeline__seeked",
                    style: _normalizeStyle({ left: `${_unref(seekedPercentage)}%` })
                  },
                  null,
                  4
                  /* STYLE */
                ), [
                  [_vShow, _unref(mouseEntered)]
                ]),
                _createElementVNode(
                  "div",
                  {
                    class: "magic-player-timeline__scrubbed",
                    style: _normalizeStyle({ left: `${_unref(scrubbedPercentage)}%` })
                  },
                  null,
                  4
                  /* STYLE */
                )
              ])
            ])
          ],
          32
          /* NEED_HYDRATION */
        )
      ]);
    };
  }
});
</script>
